module.exports = __webpack_public_path__ + "img/imgupload-square.91f9afa6.png";